module.exports = __webpack_public_path__ + "img/tax_c@2x.1040edd7.png";